import { Map } from 'immutable';
import parseItemNo from './parseItemNo';

export default function makeItemLookup(items) {
  const map = Map(items.map((item) => [item.ItemType + item.ItemNo, item]));
  return (item) => {
    if (item) {
      const key = (item.ItemType || 'ART') + parseItemNo(item.ItemNo);
      return map.get(key);
    }
    return null;
  };
}
